// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3MrCI","resendInfoText":"OnGoingPaymentBox_resendInfoText__2A6TH"};